import { Button, TableColumnType } from 'antd'
import { Organization } from '../../models/organization'

export const OrganizationListColumn = (
  onclick: (t: 'look', id: number) => void,
  startIndex: number
): TableColumnType<Organization>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '机构编码',
      dataIndex: 'orgCode',
      align: 'center',
    },
    {
      title: '预警机构',
      dataIndex: 'orgName',
      align: 'left',
    },
    // {
    //   title: "机构简称",
    //   dataIndex: "orgAbbrName",
    //   align: "center",
    // },
    // {
    //   title: "机构属性",
    //   key: "orgProperty",
    //   align: "center",
    //   render: (_, org) => (org.orgProperty === 0 ? "民营" : "公立"),
    // },
    {
      title: '上报卫健委(局)',
      dataIndex: 'osName',
      align: 'left',
    },
    {
      title: '操作',
      align: 'center',
      width: '5rem',
      render: function Element(_, t) {
        return (
          <div>
            <Button
              type='primary'
              ghost
              size='small'
              onClick={(e: any) => {
                onclick('look', t.orgId)
              }}
            >
              查看详情
            </Button>
          </div>
        )
      },
    },
  ]
}
